/**
 * GRANEL packing: loose master cartons in the container.
 * - Height-first stepped fill with plateaus at least 2 columns wide
 * - Reshape to minimize unoccupied area below the filler line
 * - Filler line: top-right of highest rightmost master → container lower-right floor
 */

import {
  packAll,
  DEFAULT_MIN_BELOW_FRACTION,
  DIAGONAL_PEAK_RIGHT_TO_END,
} from "./steppedPacker";

/** GRANEL-only: keep the same column height for at least this many columns. */
export const GRANEL_MIN_STEP_WIDTH = 2;

/**
 * @param {object} input
 * @param {number} input.masterWidth
 * @param {number} input.masterHeight
 * @param {number} input.masterDepth
 * @param {number} input.quantity - number of master cartons
 * @param {number} input.contL
 * @param {number} input.contW
 * @param {number} input.contH
 * @param {number} [input.minBelowFraction]
 */
export function packGranel(input) {
  const {
    masterWidth,
    masterHeight,
    masterDepth,
    quantity,
    contL,
    contW,
    contH,
    minBelowFraction = DEFAULT_MIN_BELOW_FRACTION,
  } = input;

  return packAll(
    masterWidth,
    masterHeight,
    masterDepth,
    quantity,
    [[contL, contW, contH]],
    "master",
    {
      minBelowFraction,
      minStepWidth: GRANEL_MIN_STEP_WIDTH,
      diagonalMode: DIAGONAL_PEAK_RIGHT_TO_END,
      preferLength: false,
      minimizeUnoccupied: true,
    }
  );
}
